import styled from 'styled-components'

export const Container = styled.div`
    max-width: 1600px;
    margin: auto;
    margin-top: 2rem;
    padding: 0 20px;
    margin-bottom: 5rem;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }
`

export const FormContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1000px;
    margin: auto;
    padding: 0 20px;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }
`

export const FormContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`
